import React, { useEffect, useState } from 'react'

// Phase 1: this page is a thin compatibility shim. Auth now runs through
// Devise + OmniAuth at /users/auth/google_oauth2 (server-rendered redirect
// to Google, then session cookie). Phase 2 will replace this with a proper
// TS Home page, but a single button is fine for now.
//
// `omniauth-rails_csrf_protection` (in the Gemfile) requires the OmniAuth
// passthru request to be a POST with a CSRF token, so we render a real
// form rather than a link. The CSRF token comes from the meta tag Rails
// injects into the SPA shell.
export default function Login() {
  const [csrfToken, setCsrfToken] = useState('')

  useEffect(() => {
    const meta = document.querySelector('meta[name="csrf-token"]')
    setCsrfToken(meta ? meta.getAttribute('content') || '' : '')
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-semibold tracking-tight text-slate-900">
            kyu <span className="text-accent-600">Initiative Signals</span>
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Cross-agency knowledge for kyu Collective
          </p>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white shadow-sm p-8">
          <h2 className="text-lg font-semibold text-slate-900 mb-1">Sign in</h2>
          <p className="text-sm text-slate-500 mb-6">
            Use your organization Google account. Sign-in is only available for
            people whose accounts have already been created by an administrator.
          </p>

          <form action="/users/auth/google_oauth2" method="post">
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <button
              type="submit"
              className="block w-full text-center rounded-md bg-slate-900 hover:bg-slate-800 text-white px-4 py-2.5 font-medium transition"
            >
              Sign in with Google
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-xs text-slate-500">
          Don&apos;t have an account? Contact your administrator.
        </p>
      </div>
    </div>
  )
}
